import { memo } from 'react';
import ApplePassFront from './ApplePassFront';
import ApplePassBack from './ApplePassBack';
import { PreviewData } from '../../../../../store/types/template';

const ApplePassPreview = ({
  selectedPassTab,
  previewData,
  featuresSide,
}: {
  selectedPassTab: string;
  previewData: PreviewData;
  featuresSide: 'Front' | 'Back';
}) => {
  const effectiveSide =
    selectedPassTab === 'Features'
      ? (featuresSide ?? 'Front')
      : selectedPassTab;

  const notifOpen =
    previewData.focusedField === 'notificationHeader' ||
    /^notificationMessages\.\d+\.label$/.test(previewData.focusedField || '') ||
    /^locations\.\d+\.message$/.test(previewData.focusedField || '');

  return (
    <>
      {effectiveSide === 'Front' && (
        <ApplePassFront
          previewData={previewData}
          createTemplate={true}
          templatesPage={false}
          notifOpen={notifOpen}
        />
      )}
      {effectiveSide === 'Back' && (
        <ApplePassBack
          previewData={previewData}
          createTemplate={true}
          templatesPage={false}
          notifOpen={notifOpen}
        />
      )}
    </>
  );
};

export default memo(ApplePassPreview);
